@switch (columnName) {
  @case ('confirm') {
    <button mat-button>
      <mat-icon>
        {{ element.type === paxOverviewType.Current ? 'transfer_within_a_station' : 'done' }}
      </mat-icon>
    </button>
  }
  @case ('arrivalDateTime') {
    {{ element.from || element.arrival | date: dateTimeFormat }}
  }
  @case ('departureDateTime') {
    {{ element.to | date: dateTimeFormat }}
  }
  @case ('from') {
    {{ element.from | date: dateTimeFormat }}
  }
  @case ('to') {
    @if (element.isInfiniteEndDate) {
      {{ 'notDefined' | translate }}
    } @else {
      {{ element.to | date: dateTimeFormat }}
    }
  }
  @case ('plannedArrivalDate') {
    {{ element.plannedStartDate | date: dateTimeFormat }}
  }
  @case ('plannedDepartureDate') {
    {{ element.plannedEndDate | date: dateTimeFormat }}
  }
  @case ('plannedEndDate') {
    {{ element.plannedEnd | date: dateTimeFormat }}
  }
  @case ('status') {
    {{ element.status | onBoardStatusMap | translate }}
  }
  @case ('currentActivityEndDate') {
    @if (element.currentActivityIsInfiniteEndDate) {
      {{ 'notDefined' | translate }}
    } @else {
      {{ element.currentActivityEndDate | date: dateTimeFormat }}
    }
  }
  @case ('period') {
    @if (element.isInfiniteEndDate) {
      {{ 'notDefined' | translate }}
    } @else {
      {{ element | dateDiff }} {{ 'days' | translate }}
    }
  }
  @case ('type') {
    {{ (element.type === personOnBoardType.Personnel ? 'employee' : 'pax') | translate }}
  }
  @case ('fullName') {
    {{ element.firstName }} {{ element.lastName }}
  }
  @case ('roles') {
    @for (role of element.roles; track role) {
      <div>
        {{ role.name }}
      </div>
    }
  }
  @case ('date') {
    {{ element.date | date: dateTimeFormat }}
  }
  @case ('previousFrom') {
    @if (element.previousFrom) {
      {{ element.previousFrom | date: dateTimeFormat }}
    }
  }
  @case ('currentFrom') {
    @if (element.currentFrom) {
      {{ element.currentFrom | date: dateTimeFormat }}
    }
  }
  @case ('previousTo') {
    @if (element.previousTo) {
      {{ element.previousTo | date: dateTimeFormat }}
    }
  }
  @case ('currentTo') {
    @if (element.currentTo) {
      {{ element.currentTo | date: dateTimeFormat }}
    }
  }
  @case ('workSchedule') {
    @if (element.hasAssignedWorkSchedules && !element.needsDocumentationCompletion) {
      <button mat-button [matTooltip]="'userNeedsShiftManningSignOff' | translate">
        <mat-icon>logout</mat-icon>
      </button>
    } @else {
      @if (!element.hasAssignedWorkSchedules && element.hasWatchDuties) {
        <button mat-button [matTooltip]="'noWorkScheduleWarning' | translate">
          <mat-icon>warning</mat-icon>
        </button>
      }
    }
  }
  @case ('tripName') {
    {{ element.tripName || element.name }}
  }
  @case ('department') {
    {{ element.department?.name }}
  }
  @case ('tripChanges') {
    @if (tripVersionReasonLabels[element.tripVersionReason]) {
      <span class="pr-05">
        {{ tripVersionReasonLabels[element.tripVersionReason] | translate }}
      </span>
    }
    @if (element?.crewMembersChanges?.length) {
      <div class="crew-members text-secondary">
        @for (crewMember of element.crewMembersChanges; track $index) {
          <div>
            {{ crewMember.name }}: {{ crewMember.from | date: dateTimeFormat }} -
            {{ crewMember.to | date: dateTimeFormat }}
          </div>
        }
      </div>
    }
    @for (fieldChange of fieldChangesWithTranslations; track fieldChange) {
      <div class="field-change">
        {{ fieldChange.fieldName | translate }}
        @if (fieldChange.translationKey) {
          {{ fieldChange.translationKey | translate }}
        }
        <span class="text-secondary">
          <app-text-overflow-label [text]="fieldChange.value"></app-text-overflow-label>
        </span>
      </div>
    }
  }
  @case ('userName') {
    <div class="align-items-center display-flex">
      <app-ui-navigate-to-person
        [id]="element.userId"
        type="user"
        [stopPropagation]="true"
      ></app-ui-navigate-to-person>
      {{ element.userName }}
    </div>
  }
  @default {
    {{ element[columnName] }}
  }
}
